import { useState } from 'preact/hooks';
import { ProductTable } from './product-table';
import { ProductDetail } from './product-detail';

export function ProductsTab() {
  const [view, setView] = useState<'list' | 'detail'>('list');
  const [selectedBarcode, setSelectedBarcode] = useState('');

  const openDetail = (barcode: string) => {
    setSelectedBarcode(barcode);
    setView('detail');
  };

  const backToList = () => {
    setView('list');
  };

  if (view === 'detail') {
    return <ProductDetail barcode={selectedBarcode} onBack={backToList} />;
  }

  return <ProductTable onSelect={openDetail} />;
}
